/**
 * Computes the logical AND of the array elements
 * @param array the array to compute logical AND for
 * @returns true if all elements are true, false otherwise
 */
export function arrayAND(array) {
    let result = true;
    const length = array.length;
    for (let i = 0; i < length; i++) {
        result = (result && array[i]);
        if (result === false) {
            break; // break the loop, the AND result will be false now regardless
        }
    }
    return result;
}
//# sourceMappingURL=arrayAND.js.map